/** @format */

import React from 'react';
import {createRoot} from 'react-dom/client';

import Quoter from './quoter';
import ErrorBoundary from './error_boundary';
import {AccountContextProvider} from 'frontier-utilities';

// Add the design system's global scope CSS to the page.
import '@/components/sttark_design_system/index.scss';

const element = document.getElementById('root');
if (element) {
    const root = createRoot(element);
    const userId = parseInt(element.dataset['user_id']);
    const isGuest = parseInt(element.dataset['is_guest']) === 1;
    const isAdmin = parseInt(element.dataset['is_admin']) === 1;
    const userCompany = element.dataset['user_company'];

    root.render(
        <ErrorBoundary>
            <AccountContextProvider>
                <Quoter
                    userId={userId}
                    isGuest={isGuest}
                    orderPreload={orderPreload}
                    cartPreload={cartPreload}
                    processingTimes={processingTimesPreload}
                    formFactors={formFactorsPreload}
                    substrates={substratesPreload}
                    substrateAttributes={substrateAttributesPreload}
                    filterableSubstrates={filterableSubstratesPreload}
                    substrateCategories={substrateCategoriesPreload}
                    laminates={laminatesPreload}
                    isAdmin={isAdmin}
                    userCompany={userCompany}
                />
            </AccountContextProvider>
        </ErrorBoundary>
    );
}
